'use client';

import { Button } from '@/shared/components/atoms/Button';
import { cn } from '@/styles/utils';
import { useEffect } from 'react';
import { useChatStore } from '../../stores/chatStore';

export function ChatButton() {
  const { toggleOverlay, contacts, connectSocket, isConnected } = useChatStore();

  const totalUnreadCount = contacts.reduce((sum, contact) => sum + contact.unreadCount, 0);

  // Initialize socket connection when component mounts
  useEffect(() => {
    if (!isConnected) {
      connectSocket();
    }
  }, [isConnected, connectSocket]);

  return (
    <Button
      variant="outline"
      size="lg"
      className={cn(
        'bg-white text-[#2563EB] border border-[#2563EB] px-3 py-2 gap-2',
        totalUnreadCount > 0 ? 'pr-3' : '',
      )}
      onClick={toggleOverlay}
      aria-label="채팅 열기"
    >
      EZTalk
      {totalUnreadCount > 0 && (
        <span className="body-14m w-5 h-5 rounded-full bg-[#2563EB] text-white border-0 flex items-center justify-center">
          {totalUnreadCount > 99 ? '99' : totalUnreadCount}
        </span>
      )}
    </Button>
  );
}